<script lang="ts">
  // components
  import { Alert, AlertLevel } from "@getprovi/fizzy-svelte";

  export let suspendedFrom: string;

  let content =
    "Your account is temporarily suspended from making payments online with " +
    suspendedFrom +
    ", including any payments that were previously scheduled. Provi cannot lift this suspension. Contact " +
    suspendedFrom +
    " accounting to have it lifted.";
</script>

<div class="fizz-container fizz-stack-24">
  <div class="fizz-flex-item fizz-inset-horizontal-16" data-testid="payments_suspended_banner">
    <Alert
      level={AlertLevel.Error}
      title={"ProviPay access temporarily suspended for " + suspendedFrom}
      text={content}
    />
  </div>
</div>
